import {Component, Input, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReactiveFormsModule} from "@angular/forms";

interface Column {
  header: string;
  field: string;
}

@Component({
  selector: 'app-search-result-table',
  templateUrl: './search-result-table.component.html',
  standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
  styleUrl: './search-result-table.component.css'
})
export class SearchResultTableComponent {
  @Input() title!: string;
  @Input() columns: Column[] = [];
  @Input() data: any[] = [];
  @Input() pageSize: number = 10;
  @Input() currentPage: number = 1;
  downloadedTable = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.downloadedTable = false;
    }
  }

  get pagedData() {
    const totalPages = this.totalPages;

    if (totalPages === 0) return [];

    if (this.currentPage > totalPages) {
      this.currentPage = 1;
    }

    const start = (this.currentPage - 1) * this.pageSize;
    return this.data.slice(start, start + this.pageSize);
  }

  get totalPages(): number {
    return Math.ceil(this.data.length / this.pageSize);
  }

  prevPage() { if (this.currentPage > 1) this.currentPage--; }
  nextPage() { if (this.currentPage < Math.ceil(this.data.length / this.pageSize)) this.currentPage++; }

  displayValue(row: any, field: string): string {
    const val = row[field];
    if (val === null || val === undefined || val === '') return 'N/A';
    return val;
  }

  // export data in a csv file
  exportCSV(data: any[], fileName: string) {
    this.downloadedTable = false;
    if (!data || !data.length) return;

    const columns = this.columns;
    const csvRows: string[] = [];

    // headers
    const headers = columns.map(col => `"${col.header}"`);
    csvRows.push(headers.join(','));

    // rows
    data.forEach(row => {
      const values = columns.map(col => {
        let val = row[col.field];
        if (val == null) val = '';
        val = val.toString().replace(/"/g, '""');
        return `"${val}"`;
      });
      csvRows.push(values.join(','));
    });

    const csvContent = csvRows.join('\r\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.downloadedTable = true;
  }
  protected readonly Math = Math;
}
